import { reactive } from "vue";

export const AccountStore = reactive({
  accountInfo: null,
  loginUrl:null,
  setValue(vue) {
    this.accountInfo = vue;
  },
  setLoginUrl(url) {
    this.loginUrl = url;
  },
});
